import { RESET, ARQUIVOS_DIGITALIZADOS_LIST, ARQUIVOS_DIGITALIZADOS_LIST_FAILED } from '../actions/Events';

export default function (state = {}, action) {
  switch (action.type) {
    case ARQUIVOS_DIGITALIZADOS_LIST:
      return { ...state, results: action.payload, error: null }

    case ARQUIVOS_DIGITALIZADOS_LIST_FAILED:
      return { ...state, results: null, error: action.payload }

    case RESET:
      return {}

    default:
      return state
  }
}

